import axios from "axios";
import ConstantList from "../appConfig";
import HttpService from "./HttpService";

const API_PATH = ConstantList.API_EN_POINT + "/report";

// Helper function to add payment method limit flag
const addPaymentMethodLimit = (data) => {
  const limitMethods = ConstantList.PAYMENT_METHOD_LIMITS;
  if (Array.isArray(limitMethods) && limitMethods.length > 0) {
    return {
      ...data,
      limitPaymentMethodCodes: limitMethods,
    };
  }
  return data;
};
const API_STORE_REQUEST_PATH = ConstantList.API_EN_POINT + "/store-request";
const API_PATH_2 = ConstantList.API_ENPOINT + "/public/test";
const API_PATH_STORE = ConstantList.API_EN_POINT_STORE + "/store-report";
const API_PATH_VISIT = ConstantList.API_EN_POINT + "/visit";
const API_PATH_APPOINMENT = ConstantList.API_EN_POINT + "/appointment";
const API_PATH_STAFF_REVENUE = ConstantList.API_EN_POINT + "/staff-revenue";
const API_PATH_REPORT_CARD = ConstantList.API_EN_POINT + "/treatment-plan-card";
const API_PATH_REPORT_INVOICE_ITEM_SUMMARY =
  ConstantList.API_EN_POINT + "/report";
const API_PATH_REVENUE = ConstantList.API_EN_POINT + "/revenue-report";

export const pagingCancelInvoiceReport = (searchObject) =>
  axios.post(API_PATH + "/voucher-cancel-report", searchObject);

export const pagingpagingVisitReport = (searchObject) =>
  axios.post(API_PATH_VISIT + "/search-by-page", searchObject);

export const pagingAppointmentReport = (searchObject) =>
  axios.post(API_PATH_APPOINMENT + "/search-check-in-report", searchObject);

export const pagingIinvoiceItemSummaryReport = (searchObject) =>
  axios.post(
    API_PATH_REPORT_INVOICE_ITEM_SUMMARY + "/invoice-item-summary-order-report",
    searchObject
  );

export const pagingExamPatient = (searchObject) =>
  axios.post(API_PATH + "/report-paging-exam-patient", searchObject);
export const pagingSurgeryReport = (searchObject) =>
  axios.post(API_PATH + "/report-paging-surgery", searchObject);
export const pagingReceptionPatient = (searchObject) =>
  axios.post(API_PATH + "/report-paging-patient-reception", searchObject);
export const pagingSurgicalConsultationReport = (searchObject) =>
  axios.post(API_PATH + "/report-surgical-consultation", searchObject);
export const pagingAppointmentPatient = (searchObject) =>
  axios.post(API_PATH + "/report-waiting-exam", searchObject);
export const pagingServiceReport = (searchObject) =>
  axios.post(API_PATH + "/report-service", searchObject);
export const pagingServiceReportByPersonal = (searchObject) =>
  axios.post(API_PATH + "/report-service-personal", searchObject);
export const getEstimateDrug = (searchObject) =>
  axios.post(API_STORE_REQUEST_PATH + "/estimate-drug", searchObject);
export const getEstimateMedicalSupply = (searchObject) =>
  axios.post(API_STORE_REQUEST_PATH + "/estimate-medical-supply", searchObject);
export const getDetailSurgeryReport = (encounterId) =>
  axios.get(API_PATH + "/get-detail-surgery-report/" + encounterId);
export const pageTechnicalServicesReport = (searchObject) =>
  axios.post(API_PATH + "/report-technical-services-report", searchObject);
export const pageOverViewReport = (searchObject) =>
  axios.post(API_PATH + "/staff-revenue-distribution-report", searchObject);

export const getVoucherItemSalesAllocation = (searchObject) => {
  return axios.post(
    API_PATH + "/voucher-item-sales-allocation-report",
    searchObject
  );
};
//bao cao tam ung ngoai tru
export const pagingOutPatientAdvanceMoneyReport = (searchObject) =>
  axios.post(API_PATH + "/page-voucher-advance-out-patient", searchObject);

//bao cao tam ung noi tru
export const pagingInPatientAdvanceMoneyReport = (searchObject) =>
  axios.post(API_PATH + "/page-voucher-advance-in-patient", searchObject);

//bao cao hoan ung ngoai tru
export const pagingOutPatientRefundMoneyReport = (searchObject) =>
  axios.post(API_PATH + "/page-voucher-refund-out-patient", searchObject);

//bao cao hoan ung noi tru
export const pagingInPatientRefundMoneyReport = (searchObject) =>
  axios.post(API_PATH + "/page-voucher-refund-in-patient", searchObject);

//bao cao tam ung ngoai tru cac phong
export const pagingOutPatientPrepaymentReport = (searchObject) =>
  axios.post(API_PATH_2 + "/get-report", searchObject);
// bao cao noi/ngoai tru hoan/tam ung ( bc dung chung )
export const pagingExpenseVoucherReport = (searchObject) =>
  axios.post(API_PATH + "/get-expense-voucher-report", searchObject);
// bao cao so nguoi kham va so luot kham
export const clinicActivitesReport = (searchObject) =>
  axios.post(API_PATH + "/clinic-activity-report", searchObject);

export const pagingRegistrationListPatient = (searchObject) =>
  axios.post(API_PATH + "/report-examination-registration-list", searchObject);

// bao cao tong so benh nhan theo nhom tuoi va gioi tinh
export const reportPatientByAgeAndGender = (searchObject) =>
  axios.post(API_PATH + "/report-patient-by-gender-and-age", searchObject);
// bao cao tong so benh nhan khám ngoại trú
export const reportOutPatient = (searchObject) =>
  axios.post(API_PATH + "/report-outpatient", searchObject);
//bao cao dich vu da dk
export const reportServicesPerformed = (searchObject) =>
  axios.post(API_PATH + "/report-service-performed", searchObject);
//bao cao doanh thu
export const reportFinance = (searchObject) =>
  axios.post(API_PATH + "/report-finance", searchObject);
//bao cao doanh thu chi tiết
export const reportFinanceDetails = (searchObject) =>
  axios.post(API_PATH + "/report-finance-details", searchObject);

//bao cao doanh thu chi tiết
export const reportIncomeExpenditure = (searchObject) =>
  axios.post(API_PATH + "/revenue-report-by-page", searchObject);

//Báo cáo thu chi tổng hợp
export const reportConsolidatedVoucher = (searchObject) =>
  axios.post(API_PATH + "/consolidated-voucher-report", searchObject);

//bao cao số lượt tiếp nhận theo phòng
export const reportServiceRequestItemByRoom = (searchObject) =>
  axios.post(API_PATH + "/report-service-request-item-by-room", searchObject);

//bao cao bn theo phong
export const patientByRoom = (obj) =>
  axios.post(API_PATH + "/report-patients-by-room", obj);

//bao cao ton kho theo thuoc
export const inventoryBydrug = (obj) =>
  axios.post(API_PATH_STORE + "/paging-inventory-report-by-drug", obj);

export const getListReportPrintByVisitGroupBySampleCode = (obj) =>
  axios.post(API_PATH + "/get-print-report-group-by-sample-code", obj);

export const reportByCustomerSourceInEpi = (obj) =>
  axios.post(API_PATH + "/report-by-customer-source-in-epi", obj);

export const getPrintReportGroupBySampleCodeId = (obj) =>
  axios.post(API_PATH + "/get-print-report-group-by-sample-code-id", obj);

export const reportPatientListProcedures = (obj) =>
  axios.post(API_PATH + "/report-surgery-history-of-patient", obj);

export const reportRetailRequirements = (obj) =>
  axios.post(API_PATH + "/report-retail-requirements", obj);

export const reportServiceByGroup = (obj) =>
  axios.post(API_PATH + "/report-service-by-group", obj);

export const reportRevenueByAssigner = (searchObject) =>
  axios.post(API_PATH + "/revenue-report-by-assigner", searchObject);

export const reportByServiceRequestItem = (obj) =>
  axios.post(API_PATH + "/search-by-page-service-request-item", obj);

export const reportRevenueBySubject = (obj) =>
  axios.post(API_PATH + "/get-revenue-by-patient-type-service", obj);

export const reportVoucher = (obj) =>
  axios.post(
    API_PATH + "/voucher-report-by-payment-method",
    addPaymentMethodLimit(obj)
  );

export const reportVoucherExpense = (obj) =>
  axios.post(API_PATH + "/voucher-expense-report", obj);

export const reportSalesAllocation = (obj) =>
  axios.post(API_PATH + "/voucher-item-sales-allocation-report", obj);

export const reportDebt = (obj) =>
  axios.post(API_PATH + "/invoice-item-accounts-debt-report", obj);

export const reportRevenueAllocation = (obj) =>
  axios.post(API_PATH + "/invoice-item-revenue-allocation-report", obj);

export const reportSales = (obj) =>
  axios.post(API_PATH + "/invoice-item-sales-report", obj);

export const reportRevenueDetails = (obj) =>
  axios.post(
    API_PATH + "/voucher-item-revenue-details-report",
    addPaymentMethodLimit(obj)
  );

export const reportCheckin = (obj) =>
  axios.post(API_PATH + "/visit-check-in-report", obj);

export const searchRevenuePayment = (obj) =>
  axios.post(API_PATH_STAFF_REVENUE + "/search-by-page", obj);

export const updateListStaffRevenue = (obj) =>
  axios.post(
    API_PATH_STAFF_REVENUE + "/update-list-staff-revenue-by-voucher-item",
    obj
  );
export const getRevenueDepartmentGroup = (obj) =>
  axios.post(
    API_PATH + "/get-revenue-department-group",
    addPaymentMethodLimit(obj)
  );

export const getRevenueReport = (obj) =>
  axios.post(API_PATH_REVENUE + "/get-revenue-report", obj);

// Gộp get-revenue-report + count + total + report-revenue-source + report-revenue-patient-source
// vào 1 request (backend materialize CTE nặng 1 lần thay vì chạy lại 4-5 lần).
export const getRevenueReportCombined = (obj) =>
  axios.post(API_PATH_REVENUE + "/get-revenue-report-combined", obj);

export const countRevenueReport = (obj) =>
  HttpService.getAxiosClient().post(
    API_PATH_REVENUE + "/count-revenue-report",
    obj
  );

export const exportExcelRevenue = (obj) => {
  let url = API_PATH_REVENUE + "/export-excel";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const totalRevenueReport = (obj) =>
  HttpService.getAxiosClient().post(
    API_PATH_REVENUE + "/total-revenue-report",
    obj
  );

export const reportRevenueSource = (obj) =>
  axios.post(API_PATH_REVENUE + "/report-revenue-source", obj);

export const reportRevenuePatientSource = (obj) =>
  axios.post(API_PATH_REVENUE + "/report-revenue-patient-source", obj);

export const searchPriceReport = (obj) =>
  axios.post(API_PATH + "/price-report", obj);

export const getReportRevenueGroupService = (obj) =>
  axios.post(API_PATH_REVENUE + "/report-revenue-service-group", obj);

export const getReportRevenueGroupServiceDetail = (obj) =>
  axios.post(API_PATH_REVENUE + "/report-revenue-service-group-detail", obj);

export const getInvoiceItemDebtReport = (obj) =>
  axios.post(API_PATH + "/invoice-item-debt-report", obj);

export const reportDeduction = (obj) =>
  axios.post(API_PATH + "/deduction-report", obj);

export const exportRevenueSource = (obj) => {
    let url = API_PATH_REVENUE + "/export-excel-report-revenue-source";
    return axios({
        url: url,
        method: "POST",
        responseType: "blob",
        data: obj
    });
}

export const exportExcelInvoiceItemDebtReport = (obj) => {
  return axios({
    url: API_PATH + "/invoice-item-debt-report/export-excel",
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportExcelDeductionReport = (obj) => {
  return axios({
    url: API_PATH + "/deduction-report/export-excel",
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportExcelPriceReport = (obj) => {
  return axios({
    url: API_PATH + "/price-report/export-excel",
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const searchMedicalEquipmentUsageReport = (obj) =>
  axios.post(API_PATH + "/medical-equipment-usage-report", obj);

export const exportExcelMedicalEquipmentUsageReport = (obj) =>
  axios({
    url: API_PATH + "/medical-equipment-usage-report/export-excel",
    method: "POST",
    responseType: "blob",
    data: obj,
  });

export const exportExcelInvoiceItemRevenueAllocationReport = (obj) => {
  return axios({
    url: API_PATH + "/invoice-item-revenue-allocation-report/export-excel",
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};